import { gql, useMutation } from '@apollo/client';
import { Button, Modal, notification, Typography } from 'antd';
import React, { useCallback, useState } from 'react';

const { Text, Title, Paragraph } = Typography;

export const deleteMiracleMutation = gql`
  mutation DeleteMiracleForAdmin($_id: ID!) {
    deleteMiracleForAdmin(_id: $_id) {
      deletedId
    }
  }
`;

const DeleteMiracleModal = ({ visible, onFinish, onCancel }) => {
  const { miracle } = visible || {};
  const [loading, setLoading] = useState(false);
  const [deleteMiracle] = useMutation(deleteMiracleMutation);

  const handleDelete = useCallback(async () => {
    setLoading(true);
    try {
      if (miracle) {
        await deleteMiracle({
          variables: {
            _id: miracle._id,
          },
        });
        notification.success({
          message: 'Saved',
          description: 'Testimony deleted successfully',
        });
      }
      onFinish();
    } catch (err) {
      console.error(err);
      notification.error({
        message: 'Error',
        description: 'There was an error deleting your testimony',
      });
    }
    setLoading(false);
  }, [miracle, deleteMiracle, onFinish]);

  return (
    <>
      <Modal
        header={null}
        open={visible}
        closable={false}
        destroyOnClose={true}
        maskClosable={!loading}
        footer={null}
        onCancel={onCancel}
        styles={{
          body: {
            paddingTop: 16,
            paddingBottom: 16,
          },
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <Title>Delete Testimony</Title>
          <Paragraph>
            {`Are you sure you want to delete the following testimony?`}
          </Paragraph>
          <Paragraph ellipsis={{ rows: 2, expandable: true, symbol: 'more' }}>
            {miracle?.desc}
          </Paragraph>
          <div style={{ height: 16 }} />
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              disabled={loading}
              style={{ marginRight: 16 }}
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button loading={loading} type="primary" onClick={handleDelete}>
              Delete
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DeleteMiracleModal;
